import { useRequest } from 'ahooks'
import { Form, FormItemProps, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
interface ProjectNameInputProps {
  selfId?: string
  type: 'project' | 'portfolio'
}

export const ProjectNameInput: React.FC<FormItemProps & ProjectNameInputProps> = ({ selfId, type, ...props }) => {
  const { i18n, t } = useTranslation()
  const [name, setName] = React.useState('')
  const { data, loading, run } = useRequest(
    (name: string) => ({
      url: type === 'project' ? '/api/project/getProjectByName' : '/api/portfolio/getPortfolioByName',
      params: {
        name,
      },
    }),
    { manual: true, debounceInterval: 300 }
  )

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const name = e.target.value.trim()
    setName(name)
    if (name) {
      run(name)
    }
  }

  const title = {
    project: t('project.project'),
    portfolio: t('portfolio.portfolio'),
  }[type]

  const validateStatus =
    name === '' ? undefined : loading ? 'validating' : data && data.selfId !== selfId ? 'error' : 'success'
  const help = validateStatus === 'error' ? `${t('already exists', { title })}` : null

  return (
    <Form.Item
      {...props}
      label={`${title}${i18n.resolvedLanguage === 'zh' ? '' : ' '}${t('name')}`}
      name='name'
      validateStatus={validateStatus}
      help={help}
      hasFeedback
      rules={[
        { required: true, type: 'string', whitespace: true },
        {
          message: '',
          validator: async () => (help ? Promise.reject(new Error(help)) : Promise.resolve()),
        },
      ]}
    >
      <Input onChange={onChange} />
    </Form.Item>
  )
}
